import script from "./BuyerDashboardLivingWageDonutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerDashboardLivingWageDonutChart.vue?vue&type=script&setup=true&lang=js"

import "./BuyerDashboardLivingWageDonutChart.vue?vue&type=style&index=0&id=852d3694&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-852d3694"]])

export default __exports__